import { frontendURL } from 'dashboard/helper/URLHelper';

const InternalChat = () => import('./InternalChat.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat',
    component: InternalChat,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];

export default { routes };
